import React from 'react';
import MultiSelect from './MultiSelect';

const FilteredMultiSelect = ({
  excludeKey = 'slug',
  excludeValues = [],
  options = [],
  ...props
}) => (
  <MultiSelect {...props} options={options.filter((o) => !excludeValues.includes(o[excludeKey]))} />
);

FilteredMultiSelect._hookable = true;

export default FilteredMultiSelect;
